export default {
  // General
  'saving-plan:general:more-info': 'More info',

  // Selector
  'saving-plan:selector:title': 'Annual benefit',
  'saving-plan:selector:none': 'None 0%',
  'saving-plan:selector:none:price': '€0 / year',
  'saving-plan:selector:clever': 'Clever {badge}',
  'saving-plan:selector:clever:badge': 'from 3%',
  'saving-plan:selector:clever:price': '€2.99 / year',
  'saving-plan:selector:premium': 'Premium {badge}',
  'saving-plan:selector:premium:badge': 'from 5%',
  'saving-plan:selector:premium:price': '€7.99 / year',
  'saving-plan:selector:dynamic:badge': '{discount}%',
  'saving-plan:selector:price-info':
    'For just €{price}: Extra {discount}% discount on every order!',
  'saving-plan:selector:price-info:dynamic':
    'For once {price}: at least {discount}% extra discount per order!',
  'saving-plan:selector:price-info:exact':
    'For once {price}: {discount}% extra discount per order!',

  // Info bar messages
  'saving-plan:info-bar:active':
    'Your {planName} plan is active - already reduced by {percentage}%.',
  'saving-plan:info-bar:customer-plan':
    'Your annual benefit ({planName}) is active - at least {percentage}% discount secured.',
  'saving-plan:info-bar:cart': 'Already {percentage}% cheaper with your selected {planName} plan',
  'saving-plan:info-bar:savings':
    'Your annual benefit {planName}: <strong>{amount}</strong> saved.',
  'saving-plan:info-bar:account:page': 'Annual benefit {planName} {percentage}%',
  'saving-plan:info-bar:account:page:active-until': 'Active until {activeUntil}',
  'saving-plan:info-bar:account:page:more-info': 'More info',
  'saving-plan:info-bar:account:page:more-info:label': 'More information about this annual benefit',
  'saving-plan:info-bar:subscriptions:page':
    'Your subscription products: {percentage}% cheaper with annual benefit {planName}',

  // Cart element
  'saving-plan:cart:banner': 'Save {amount} on this order now!',
  'saving-plan:cart:title:clever': 'Annual Benefit Clever',
  'saving-plan:cart:title:premium': 'Annual Benefit Premium',
  'saving-plan:cart:description': 'Annual benefit: Save for one year on every order',
  'saving-plan:cart:benefit:pay-once': 'Pay once, save for 12 months',
  'saving-plan:cart:benefit:discount': 'Discount on food & snacks',
  'saving-plan:cart:benefit:no-renewal': 'No automatic renewal',
  'saving-plan:cart:price:clever': 'Once €2.99',
  'saving-plan:cart:price:premium': 'Once €7.99',
  'saving-plan:cart:activate': 'Activate now',
  'saving-plan:cart:pet-profile-benefit': 'Save more with pet profile!',
  'saving-plan:cart:increase-discount': 'Increase discount',

  // More info sheet
  'saving-plan:more-info:not-active:title': 'Extra discount on every order',
  'saving-plan:more-info:active:title': 'Your annual benefit explained',
  'saving-plan:more-info:column:plan': 'Annual benefit',
  'saving-plan:more-info:column:discount': 'Discount',
  'saving-plan:more-info:none': 'None - Free',
  'saving-plan:more-info:none:discount': '0%',
  'saving-plan:more-info:clever': 'Clever - €2.99/year',
  'saving-plan:more-info:clever:without-profile': 'Without pet profile: 3%',
  'saving-plan:more-info:clever:with-profile': 'With pet profile: from 5%',
  'saving-plan:more-info:premium': 'Premium - €7.99/year',
  'saving-plan:more-info:premium:without-profile': 'Without pet profile: 5%',
  'saving-plan:more-info:premium:with-profile': 'With pet profile: from 8%',
  'saving-plan:more-info:benefit:duration': 'Lock in price advantage for 12 months',
  'saving-plan:more-info:benefit:no-renewal': 'No automatic renewal',
  'saving-plan:more-info:benefit:all-products': 'Applies to all food types & snacks',
  'saving-plan:more-info:benefit:one-per-account': 'One annual benefit per account',
  'saving-plan:more-info:benefit:combinable': 'Also combinable with subscription & voucher',
  'saving-plan:more-info:close': 'Close',

  // Login button
  'saving-plan:login-button:already-registered': 'Already registered?',
  'saving-plan:login-button:login-here': 'Log in here',

  // Editor
  'saving-plan:editor:title': 'Choose your annual benefit',
  'saving-plan:editor:info':
    'For just €{value}: Extra at least {discount}% discount on every order!',
  'saving-plan:editor:cancel': 'Close',
  'saving-plan:editor:save': 'Save selection',
  'saving-plan:editor:close': 'Close',
};
